<app-header [childValue]="selectedLang" (valueChanged)="onChildValueChanged($event)"></app-header>

<div class="body-container p-fluid p-formgrid justify-content-center mt-1"
    style="display: flex; align-items: center; flex-wrap: wrap;">

    <div class="field sm:col-12 md:col-12 lg:col-12 my-0 py-2 mx-0 px-2" style="display: flex; align-items: center;">
        <div class="static-button">
            <button pButton pRipple label="{{'BACK'| translate}}" icon="pi pi-arrow-left" class="back-button text-sm" (click)="goBack()"></button>
        </div>
        <div class="field sm:col-12 md:col-6 lg:col-10 px-2 photo-gallery-header"
            style="display: flex; align-items: center; justify-content: center;">
            <p>{{ 'VIDEO_GALLERY' | translate }}</p>
        </div>
    </div>
    <!-- <div class="img-conatiner">
        <p>Will back soon!</p>
    </div> -->
    <div class="video-gallery">
        <div class="video-container" *ngFor="let video of videoList">
            <iframe *ngIf="!video.isYoutubeLink" loading="lazy" [src]="video.link" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen loading="lazy" muted>
            </iframe>
            <!-- <video *ngIf="video.isYoutubeLink" class="" style="margin-bottom: 2px; border-radius: 2px; width: 100%; height: auto; object-fit: fill;" 
              controls muted loop id="myVideo" [src]="video.link" type="video/mp4" loading="lazy">
            </video> -->
            <iframe *ngIf="video.isYoutubeLink"
                loading="lazy"
                [src]="video.link"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                title="YouTube video"
              ></iframe>
            <div class="video-description">
                {{ video.description }}
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>